import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CrownContent from "./CrownPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/crown/pumps" component={CrownContent} />
          <Route path="/suppliers/crown">
            <Redirect to="/suppliers/crown/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
